// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps, react-hooks/immutability */

import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { Segment, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";

import _ from "lodash";

import { useAuth0 } from "../../../../auth/auth0";
import { useUserAuth } from "../../../../hooks/useUserAuth";

import * as trialActions from "../../../../redux/actions/trialActions";

import PublishedTrialsFlightsTable from "./PublishedTrialsFlightsTable";

const PublishedTrials = () => {
	const dispatch = useDispatch();
	const { getTokenSilently } = useAuth0();
	const userAuth = useUserAuth();

	//-- Query results
	const [publishedTrialsFlights, setPublishedTrialsFlights] = useState(null);

	//-- UI Control
	const [initialLoading, setInitialLoading] = useState(true);
	const [refreshing, setRefreshing] = useState(1);

	useEffect(() => {
		if (userAuth.currentClientId) {
			setRefreshing(true);
			getTrialsPublishedToClientOrUser(userAuth.currentClientId);
		}
	}, [userAuth.currentClientId]);

	async function getTrialsPublishedToClientOrUser(clientId) {
		const accessToken = await getTokenSilently();
		dispatch(trialActions.getTrialsPublishedToClientOrUser(clientId, accessToken))
			.then((res) => {
				const stagedTrialFlights = _.map(res, (trial) => {
					if (
						userAuth.currentClientId === trial.trialOwnerClientId ||
						userAuth.user.userInfo.basic.userId === trial.trialOwnerUserId
					) {
						trial.view = "Owner";
					} else if (
						(trial.sponsors ?? []).some(
							(s) =>
								userAuth.currentClientId === s.sponsorClientId ||
								userAuth.user.userInfo.basic.userId === s.sponsorUserId,
						) &&
						trial.publishedToTrialSponsor
					) {
						trial.view = "Sponsor";
					} else if (userAuth.currentClientId === trial.publishedByClientId) {
						trial.view = "Researcher";
					}

					return setupTrialFlightObject(trial);
				});

				setPublishedTrialsFlights(stagedTrialFlights);
				setInitialLoading(false);
				setRefreshing(false);
			})
			.catch((err) => {
				toast.error("Error loading Published Trials. Please try again.");
				setInitialLoading(false);
				setRefreshing(false);
				console.log(err);
			});
	}

	const setupTrialFlightObject = (trial) => {
		const sponsors = trial.sponsors ?? [];
		const primarySponsor =
			sponsors.find(
				(s) =>
					s.sponsorClientId === userAuth.currentClientId || s.sponsorUserId === userAuth.user.userInfo.basic.userId,
			) ?? sponsors[0];
		const stagedTrialFlight = {
			trialId: trial.trialId,
			trialName: trial.trialName,
			fieldScaleTrial: trial.fieldScaleTrial,
			flightId: trial.flightId,
			flightDate: trial.flightDate,
			flightName: trial.flightName,
			publishedDate: trial.publishedDate,
			view: trial.view,
			publishedToTrialSponsor: trial.publishedToTrialSponsor,
			company:
				trial.view !== "Sponsor"
					? trial.view === "Owner"
						? primarySponsor?.sponsorClientName
							? primarySponsor.sponsorClientName
							: primarySponsor?.sponsorCompanyName
								? primarySponsor.sponsorCompanyName
								: trial.trialOwnerClientName
						: trial.trialOwnerClientName
							? trial.trialOwnerClientName
							: trial.trialOwnerCompanyName
					: primarySponsor?.sponsorClientName,
			publishedByClientName:
				trial.view !== "Sponsor"
					? trial.view === "Researcher" || (trial.view === "Owner" && !trial.publishedToTrialSponsor)
						? trial.publishedByClientName
						: trial.trialOwnerClientName
					: trial.trialOwnerClientName,

			publishedByUserFirstName:
				trial.view !== "Sponsor"
					? trial.view === "Researcher" || (trial.view === "Owner" && !trial.publishedToTrialSponsor)
						? trial.publishedByUserFirstName
						: trial.trialOwnerFirstName
					: trial.trialOwnerFirstName,
			publishedByUserLastName:
				trial.view !== "Sponsor"
					? trial.view === "Researcher" || (trial.view === "Owner" && !trial.publishedToTrialSponsor)
						? trial.publishedByUserLastName
						: trial.trialOwnerLastName
					: trial.trialOwnerLastName,
			publishedByEmailAddress:
				trial.view !== "Sponsor"
					? trial.view === "Researcher" || (trial.view === "Owner" && !trial.publishedToTrialSponsor)
						? trial.publishedByUserEmailAddress
						: trial.trialOwnerEmailAddress
					: trial.trialOwnerEmailAddress,
			publishedToFirstName: trial.view !== "Sponsor" ? trial.trialOwnerFirstName : primarySponsor?.sponsorFirstName,
			publishedToLastName: trial.view !== "Sponsor" ? trial.trialOwnerLastName : primarySponsor?.sponsorLastName,
			publishedToEmailAddress:
				trial.view !== "Sponsor"
					? trial.view === "Researcher" || (trial.view === "Owner" && !trial.publishedToTrialSponsor)
						? trial.trialOwnerEmailAddress
						: primarySponsor?.sponsorEmailAddress
					: primarySponsor?.sponsorEmailAddress,
			publishedToClientName:
				trial.view !== "Sponsor"
					? trial.view === "Researcher" || (trial.view === "Owner" && !trial.publishedToTrialSponsor)
						? trial.trialOwnerClientId && trial.trialOwnerClientId !== "00000000-0000-0000-0000-000000000000"
							? trial.trialOwnerClientName
							: "Unassigned"
						: primarySponsor?.sponsorClientId &&
							  primarySponsor.sponsorClientId !== "00000000-0000-0000-0000-000000000000"
							? primarySponsor.sponsorClientName
							: "Unassigned"
					: primarySponsor?.sponsorClientId && primarySponsor.sponsorClientId !== "00000000-0000-0000-0000-000000000000"
						? primarySponsor.sponsorClientName
						: "Unassigned",
		};

		return stagedTrialFlight;
	};

	return initialLoading ? (
		<Loader active />
	) : !initialLoading && (!publishedTrialsFlights || publishedTrialsFlights.length === 0) ? (
		<Segment style={{ margin: 15 }}>
			<p>{"We couldn't find any published trials."}</p>
		</Segment>
	) : (
		<Segment style={{ margin: 15 }}>
			{refreshing && <Loader active />}
			{!refreshing && <PublishedTrialsFlightsTable publishedTrialsFlightsData={publishedTrialsFlights} />}
		</Segment>
	);
};

export default PublishedTrials;
